'use strict';

import { NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { NotificationComponent } from './component';
import { LKIcon} from '../icon/module';
import { NotificationService } from './service';
import {LKTruncation} from "../truncation/module";

@NgModule({
  imports     : [
    BrowserModule,
    LKIcon,
    LKTruncation
  ],
  declarations: [NotificationComponent],
  exports     : [NotificationComponent],
  providers   : [NotificationService]
})
export class LKNotification {
}
